import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  position: relative;
  background: var(--sidebar-bg);
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  height: calc(100vh - 57px);
  .outside-click {
    position: absolute;
    width: calc(100vw - 80px);
    height: 100%;
    margin-left: 80px;
    @media (min-width: 851px) {
      display: none;
    }
  }
  .sidenav-text {
    font-size: 14px;
    color: #000;
    font-family: "latosemibold";
  }
  .MuiList-root {
    box-shadow: 0px 3px 5px rgb(0 0 0 / 5%);
    overflow: auto;
    max-height: calc(100vh - 146px);
  }
  .active {
    svg {
      path {
        fill: var(--theme-text) !important;
      }
    }
  }
  @media (max-width: 850px) {
    position: absolute;
    z-index: 2;
    /* height: calc(100vh - 126px); */
    .Ads {
      display: none;
    }
    &.active {
      display: flex;
    }
    &.un-active {
      display: none;
    }
  }
`;
export const WeatherIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 0;
  @media (max-width: 850px) {
    padding: 20px 0;
    margin-bottom: 71px;
  }
`;

export const SubSideNav = styled.div`
  background: var(--section-bg);
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.05);
  position: absolute;
  left: 79px;
  z-index: 2;
  &#sub-side-nav-web {
    display: flex;
  }
  &#sub-side-nav-mobile {
    display: none;
    position: absolute;
    bottom: 70px;
    right: 0;
    left: 0;
    z-index: 2;
    max-width: 450px;
    > div {
      width: 100%;
    }
  }
  /* > div {
    .MuiButton-text {
      margin: 0 auto;
    }
  } */
  @media (max-width: 850px) {
    &#sub-side-nav-web {
      display: none;
    }
    &#sub-side-nav-mobile {
      display: flex;
    }
  }
`;

export const SideNavWrapper = styled.div`
  background: linear-gradient(270deg, #000000 45.22%, #494949 106.37%);
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.05);
  position: relative;
  .message-count {
    position: absolute;
    right: 0;
    top: 0;
    background-color: red;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 0.75rem;
    min-width: 20px;
    line-height: 1;
    padding: 0 6px;
    height: 20px;
    border-radius: 10px;
    z-index: 1;
    color: #fff;
  }
  .MuiBadge-badge {
    right: 11px;
    top: 11px;
    width: auto;
  }
  :hover {
    background-color: var(--theme-background);
    color: var(--text-primary);
    font-weight: bold;
  }
  .active {
  }
  .MuiListItem-root {
    /* background: linear-gradient(270deg, #000000 45.22%, #494949 106.37%);
    box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.05); */
    /* :hover {
      background-color: var(--theme-background);
      color: var(--text-primary);
      font-weight: bold;
    } */
    .admin-icon {
      path {
        fill: #000;
      }
    }
    svg {
      path {
        fill: var(--theme-background);
      }
    }
  }
`;
